<template>
  <div>
    <RouterView v-slot="{ Component }">
      <div :key="detectLayout">
        <component :is="detectLayout">
          <Component :is="Component" />
        </component>
      </div>
    </RouterView>
    <CConnector v-if="mounted && user" />
  </div>
</template>
<script setup lang="ts">
import { computed, ComputedOptions, onMounted } from "vue";
import { useRoute } from "vue-router";
import LDefault from "@/layout/Dashboard/LDefault.vue";
import LError from "@/layout/Error/LError.vue";
import LAuth from "@/layout/Auth/LAuth.vue";
import { useClientSecret } from "@/composables/useClientSecretToken";
import LEmpty from "@/layout/Empty/LEmpty.vue";
import LMobile from "@/layout/Mobile/LMobile.vue";
import LLanding from "@/layout/Landing/LLanding.vue";
import CConnector from "@/components/CConnector.vue";
import { useMounted } from "@vueuse/core";
import { useAuthStore } from "@/modules/Auth/stores";
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const mounted = useMounted();

const authStore = useAuthStore();
const clientSecret = useClientSecret();

const user = computed(() => authStore.user);
const route = useRoute();
const layouts: { [key: string]: ComputedOptions } = {
  default: LDefault,
  error: LError,
  auth: LAuth,
  empty: LEmpty,
  mobile: LMobile,
  landing: LLanding,
};

const detectLayout = computed(() => {
  return layouts[route.meta.layout as string];
});

clientSecret.init();

onMounted(() => {
  localStorage.setItem("isOpen", "true");

  // Google Tag Manager
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line no-undef
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "GTM-T2S8HRZG");
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-T2S8HRZG");
  // End Google Tag Manager
});
onMounted(() => {
  document.dir = locale.value === "ar" ? "rtl" : "ltr";
});
useHead({
  title: "Saraf Robot - The Future of Trading is Automated",
  meta: [
    {
      name: "description",
      content:
        "Saraf Robot is an advanced trading bot that handles your investment strategy, giving you the best experience with automated solutions. It focuses on safe returns, ensuring that your money grows consistently over time. ",
    },
    {
      property: "og:title",
      content: "Saraf Robot - The Future of Trading is Automated",
    },
    {
      property: "og:description",
      content:
        "Saraf Robot is an advanced trading bot that handles your investment strategy, giving you the best experience with automated solutions. It focuses on safe returns, ensuring that your money grows consistently over time. ",
    },
    { property: "og:image", content: "/og-image.webp" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:width", content: "1200" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@sarafrobot" },
    { name: "twitter:image", content: "/og-image.webp" },
    { name: "twitter:url", content: "https://app.sarafrobot.com/" },
    { name: "twitter:image:height", content: "630" },
    { name: "twitter:image:width", content: "1200" },
  ],
  link: [{ rel: "canonical", href: "https://app.sarafrobot.com/" }],
});
</script>
